export default __webpack_public_path__ + "static/media/boundries_icn.9966bf6d.svg";